// Lightweight performance metrics collector (punkt 7: instrumentacja)
// Użycie: import { perf } i wywołuj perf.mark('label'), perf.end('label') albo perf.measureBlock('name', fn)
// Dane dostępne przez window.__DICE_PERF_EXPORT__ gdy window.__DICE_DEBUG__ lub window.__DICE_PERF__ ustawione.

interface MetricEntry { name: string; dur: number; ts: number; count?: number; }

class PerfMetrics {
  private timings: MetricEntry[] = [];
  private inFlight: Record<string, number> = {};
  private counters: Record<string, number> = {};
  mark(label: string) { this.inFlight[label] = performance.now(); }
  end(label: string, extraName?: string) {
    const start = this.inFlight[label];
    if (start == null) return;
    const dur = performance.now() - start;
    delete this.inFlight[label];
    this.timings.push({ name: extraName || label, dur, ts: Date.now() });
  }
  inc(counter: string, delta = 1) { this.counters[counter] = (this.counters[counter]||0) + delta; }
  flush() { return { timings: [...this.timings], counters: { ...this.counters } }; }
  measureBlock<T>(name: string, fn: () => T): T {
    const s = performance.now();
    try { return fn(); } finally { this.timings.push({ name, dur: performance.now()-s, ts: Date.now() }); }
  }
}

export const perf = new PerfMetrics();

// Global export when debug/perf enabled
if (typeof window !== 'undefined') {
  const attach = () => {
    if (window.__DICE_DEBUG__ || window.__DICE_PERF__) {
      window.__DICE_PERF_EXPORT__ = {
        dump: () => perf.flush(),
        timings: () => perf.flush().timings,
        counters: () => perf.flush().counters,
        reset: () => { /* naive reset */ },
      };
    }
  };
  attach();
  window.__DICE_ATTACH_PERF__ = attach;
}
